import { render, staticRenderFns } from "./ContactBookListActions.vue?vue&type=template&id=4b457dc3"
import script from "./ContactBookListActions.vue?vue&type=script&lang=js"
export * from "./ContactBookListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports